import {
	Component,
	OnInit,
	ElementRef,
	ViewChild,
	AfterViewInit
} from '@angular/core';
import { ConstantsService } from '../core/services/constants.service';
import { ImageOptimizationService } from '../core/services/image-optimization.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'app-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.css'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class AuthComponent implements OnInit, AfterViewInit {
	@ViewChild('authElement', { static: false })
	authElement!: ElementRef<HTMLElement>;

	theme!: string;

	constructor(
		private readonly constantsService: ConstantsService,
		private readonly imageOptimizationService: ImageOptimizationService
	) {
		// Constructor should remain synchronous
	}

	ngOnInit(): void {
		this.theme = this.constantsService.getCurrentSeason();

		// Preload all theme images for better performance
		this.preloadBackgroundImages();
	}

	ngAfterViewInit(): void {
		// Apply optimized background image after view initialization
		setTimeout(() => {
			this.applyOptimizedBackgroundImage();
		});
	}

	/**
	 * Apply optimized background image based on current theme
	 */
	private async applyOptimizedBackgroundImage(): Promise<void> {
		if (this.authElement && this.theme) {
			await this.imageOptimizationService.applyBackgroundImage(
				this.authElement.nativeElement,
				this.theme
			);
		}
	}

	/**
	 * Preload background images for better performance
	 */
	private async preloadBackgroundImages(): Promise<void> {
		try {
			const isMobile = this.imageOptimizationService.isMobileDevice();
			await this.imageOptimizationService.preloadAllThemes(isMobile);

			// Preload current theme first if available
			if (this.theme) {
				await this.imageOptimizationService.preloadImage(
					this.theme,
					isMobile
				);
			}
		} catch (error) {
			console.warn('Background image preloading failed:', error);
		}
	}
}
